import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  flex: 1;\n  align-items: stretch;\n\n  .name {\n    position: relative;\n    width: 90px;\n    height: 36px;\n    font-size: 16px;\n    font-weight: 600;\n    line-height: 36px;\n    color: ",
        ";\n    @media (max-width: 768px) {\n      font-size: 14px;\n      height: unset;\n      width: unset;\n      padding-right: 16px;\n    }\n  }\n\n  .filter-list {\n    flex: 1;\n    display: flex;\n    flex-wrap: wrap;\n    gap: 6px 12px;\n    padding-right: 102px;\n    transition: all 0.3s;\n\n    .stack {\n      display: flex;\n      gap: 12px;\n    }\n\n    .license-box {\n      &.hidden {\n        height: 0;\n        display: none;\n      }\n    }\n\n    @media (max-width: 768px) {\n      flex-wrap: nowrap;\n      overflow-x: auto !important ;\n      white-space: nowrap;\n      padding-right: 16px;\n      gap: 8px;\n      display: flex;\n      .stack {\n        gap: 8px;\n      }\n\n      .license-box {\n        display: flex;\n\n        &.hidden {\n          display: flex;\n          height: unset;\n        }\n      }\n    }\n  }\n\n  .ant-checkbox-wrapper {\n    display: flex;\n    height: 36px;\n    margin: 0;\n    @media (max-width: 768px) {\n      height: unset;\n      align-items: center;\n    }\n\n    .ant-checkbox {\n      display: none;\n    }\n\n    span {\n      display: block;\n      height: 36px;\n      font-size: 16px;\n      color: ",
        ";\n      font-weight: normal;\n      line-height: 1.4;\n      padding: 6px 12px;\n      cursor: pointer;\n      border: solid 1px ",
        ";\n      border-radius: 6px;\n      transition: all 0.2s linear;\n\n      @media (hover: hover) {\n        &:hover {\n          color: ",
        ";\n          background-color: ",
        ";\n        }\n      }\n      @media (max-width: 768px) {\n        font-size: 14px;\n        padding: 4px 8px;\n        height: unset;\n      }\n    }\n\n    &-checked {\n      span {\n        color: ",
        ";\n        font-weight: 600;\n        border-color: ",
        ";\n        background-color: ",
        ";\n      }\n    }\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _tagged_template_literal([
        "\n    position: absolute;\n    top: unset;\n    bottom: unset;\n    right: unset;\n    left: ",
        "px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 89px;\n    height: 36px;\n    font-size: 16px;\n    font-weight: 600;\n    color: ",
        ";\n    padding: 6px 0;\n    margin-left: 12px;\n    cursor: pointer;\n    background-color: ",
        ";\n    line-height: 1.5;\n    border-radius: 6px;\n    transition: background-color 0.2s linear, color 0.2s linear;\n    opacity: ",
        ";\n    pointer-events: ",
        ";\n\n    @media (hover: hover) {\n        &:hover {\n            background-color: ",
        ";\n        }\n    }\n    @media (max-width: 768px) {\n        display: none;\n        font-size: 14px;\n        padding: 4px 8px;\n        line-height: 1.4;\n        height: unset;\n    }\n\n    &.ant-dropdown-open {\n        color: white;\n        background-color: ",
        ";\n\n        i {\n            transform: rotate(180deg);\n            transition: 0.2s;\n        }\n\n        svg {\n            stroke: white;\n        }\n\n        .filter-list:has(&) {\n            overflow: initial;\n            max-height: initial;\n            padding-bottom: ",
        "px;\n        }\n    }\n\n    body:has(&) {\n        .ant-dropdown.filter-select {\n            @media (max-width: 768px) {\n                display: none;\n            }\n\n            &.more-filter {\n                left: calc(50vw - 506px) !important;\n                width: 1062px;\n                padding-top: 16px;\n                background-color: #fff;\n                box-shadow: none;\n                animation: none !important;\n                transition: opacity 0.2s !important;\n                display: block;\n                opacity: 1;\n\n                &.ant-slide-up-leave {\n                    display: none;\n                    opacity: 0;\n                }\n\n                @media (max-width: 1260px) {\n                    left: 127px !important;\n                    width: calc(100vw - 280px) !important;\n                    //width: calc(100vw - 240px) !important;\n                    padding-right: 0;\n                }\n\n                @media (max-width: 768px) {\n                    opacity: 0;\n                    pointer-events: none;\n                    left: 189px !important;\n                    //width: calc(100vw - 246px) !important;\n                }\n\n                .ant-dropdown-menu {\n                    display: flex;\n                    flex-wrap: wrap;\n                    gap: 12px;\n                    padding: 20px;\n                    background-color: ",
        ";\n                    box-shadow: none;\n                    border-radius: 6px;\n\n                    .ant-dropdown-menu-item {\n                        width: auto;\n                        padding: 0;\n\n                        &:hover {\n                            background-color: transparent;\n                        }\n\n                        .ant-dropdown-menu-title-content {\n                            .ant-checkbox-wrapper {\n                                height: 36px;\n                                padding: 0;\n\n                                span:not(.ant-checkbox) {\n                                    display: block;\n                                    height: 36px;\n                                    font-size: 16px;\n                                    color: ",
        "\n                                    font-weight: normal;\n                                    line-height: 1.3;\n                                    padding: 6px 12px;\n                                    cursor: pointer;\n                                    border: solid 1px ",
        ";\n                                    border-radius: 6px;\n                                    background-color: #fff;\n                                    transition: all 0.2s linear;\n\n                                    @media (hover: hover) {\n                                        &:hover {\n                                            background-color: rgba(27, 27, 41, 0.03);\n                                        }\n                                    }\n                                }\n\n                                .ant-checkbox {\n                                    display: none;\n                                }\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { ButtonWithDropdownMenu } from "@/components/Categories/Menu";
import Icon from "@/components/icon/Icon";
import { ArrowDown, Sizes } from "@/components/icon/IconList";
import { isBrowser } from "@/lib/next-utils";
import themeGet from "@styled-system/theme-get";
import { Dropdown } from "antd";
import React, { useEffect, useRef, useState } from "react";
import styled, { useTheme } from "styled-components";
import useWindowDimensions from "@/lib/web-ui/useWindowDimensions";
import { FilterTitle } from "@/components/Search/index";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
export const SearchRecommendFilter = (param)=>{
    let { onClickLicense , baseLicenses , currentKeyword  } = param;
    const { isMobile  } = useWindowDimensions();
    const buttonRefs = useRef([]);
    const moreRef = useRef(null);
    const [initBaseLicenses, setInitBaseLicenses] = useState([]);
    const [posX, setPosX] = useState(0);
    const [boxHeight, setBoxHeight] = useState(0);
    const [hasMore, setHasMore] = useState(false);
    // 줄바꿈된 체크박스들 중 가장 작은 인덱스를 반환
    const getSecondLineIdx = ()=>{
        let splitIdx = 0;
        const temp = buttonRefs.current;
        if (temp.length > 0) {
            temp.some((ref, idx)=>{
                if (!ref) return;
                if (ref.getBoundingClientRect().y !== temp[0].getBoundingClientRect().y && !!!splitIdx) {
                    splitIdx = idx;
                    return true;
                }
            });
        }
        if (!splitIdx) {
            splitIdx = initBaseLicenses.length;
            setHasMore(false);
        } else {
            setHasMore(true);
        }
        for(let i = 0; i < temp.length; i++){
            if (temp[i]) temp[i].classList[splitIdx <= i ? "add" : "remove"]("hidden");
        }
        if (splitIdx >= 1) {
            var _buttonRefs_current_;
            const lastBtnRect = (_buttonRefs_current_ = buttonRefs.current[splitIdx - 1]) === null || _buttonRefs_current_ === void 0 ? void 0 : _buttonRefs_current_.getBoundingClientRect();
            if (lastBtnRect) setPosX(lastBtnRect.width + lastBtnRect.x);
        }
        return splitIdx;
    };
    const [moreList, setMoreList] = useState([]);
    const convertDropItems = (licenses)=>{
        const resultList = [];
        licenses.forEach((license)=>{
            resultList.push({
                label: /*#__PURE__*/ _jsx(_Fragment, {
                    children: /*#__PURE__*/ _jsx(ButtonWithDropdownMenu, {
                        className: currentKeyword === license.toString() ? "selected" : "",
                        onClick: (e)=>{
                            onClickLicense(license);
                            mixpanelEvent("Search Filtered", {
                                "Filter Type": "연관교재",
                                "Filter Option Selected": license
                            });
                        },
                        children: license
                    })
                }),
                key: license
            });
        });
        if (resultList.length > 0) setMoreList(resultList);
    };
    useEffect(()=>{
        // resize 이벤트 추가
        // [보여질 필터] + [드롭박스에 들어갈 필터] 리스트 업데이트, 더보기 버튼 위치 지정
        function handleResize() {
            if (!isMobile) convertDropItems(initBaseLicenses.slice(getSecondLineIdx()));
        }
        if (isBrowser) {
            handleResize();
            window.addEventListener("resize", handleResize);
        }
        if (isMobile) {
            setInitBaseLicenses(baseLicenses);
        }
        return ()=>{
            if (isBrowser) {
                window.removeEventListener("resize", handleResize);
            }
        };
    }, [
        initBaseLicenses,
        isMobile
    ]);
    useEffect(()=>{
        let resultLicenseList = [
            ...baseLicenses
        ];
        const selectedTarget = currentKeyword;
        // 선택된 라이선스를 제일 앞으로 이동
        if (currentKeyword) {
            const index = resultLicenseList.findIndex((element)=>element.toString() === selectedTarget);
            if (index !== -1) {
                const element = resultLicenseList.splice(index, 1)[0];
                resultLicenseList.unshift(element);
            }
        }
        if (resultLicenseList.length > 0) setInitBaseLicenses(resultLicenseList);
    }, [
        baseLicenses,
        currentKeyword
    ]);
    useEffect(()=>{
        if (initBaseLicenses.length > 0) convertDropItems(initBaseLicenses.slice(getSecondLineIdx()));
    }, [
        initBaseLicenses
    ]);
    const theme = useTheme();
    const [isOpen, setIsOpen] = useState(false);
    if (baseLicenses.length > 0) return /*#__PURE__*/ _jsxs(SearchRecommendFilterWrap, {
        children: [
            /*#__PURE__*/ _jsx(FilterTitle, {
                children: "연관 교재"
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "filter-list",
                children: [
                    /*#__PURE__*/ _jsx(ButtonWithDropdownMenu, {
                        className: !currentKeyword ? "selected" : "",
                        onClick: (e)=>{
                            onClickLicense(null);
                        },
                        children: "전체"
                    }),
                    initBaseLicenses === null || initBaseLicenses === void 0 ? void 0 : initBaseLicenses.map((license, idx)=>{
                        return /*#__PURE__*/ _jsx("div", {
                            className: "license-box",
                            ref: (ref)=>{
                                buttonRefs.current[idx] = ref;
                            },
                            children: /*#__PURE__*/ _jsx(ButtonWithDropdownMenu, {
                                className: currentKeyword === license ? "selected" : "",
                                onClick: (e)=>{
                                    onClickLicense(license);
                                    mixpanelEvent("Search Filtered", {
                                        "Filter Type": "연관교재",
                                        "Filter Option Selected": license
                                    });
                                },
                                children: license
                            })
                        }, "license-box-".concat(idx));
                    }),
                    moreList && /*#__PURE__*/ _jsx(Dropdown, {
                        menu: {
                            items: moreList
                        },
                        trigger: [
                            "click"
                        ],
                        overlayClassName: "filter-select more-filter",
                        children: /*#__PURE__*/ _jsxs(MoreBtn, {
                            onClick: (e)=>{
                                e.preventDefault();
                                if (!isOpen) {
                                    mixpanelEvent("More Button Clicked", {
                                        "Filter Type": "검색결과리스트 연관교재 더보기",
                                        "Button Name": "더보기"
                                    });
                                }
                                setIsOpen(!isOpen);
                                const calculateHeight = ()=>{
                                    var _document_querySelector;
                                    const moreBox = (_document_querySelector = document.querySelector(".filter-select.more-filter")) === null || _document_querySelector === void 0 ? void 0 : _document_querySelector.getBoundingClientRect();
                                    const moreBoxOffsetTop = moreBox === null || moreBox === void 0 ? void 0 : moreBox.height;
                                    if (!!moreBoxOffsetTop && moreBoxOffsetTop !== boxHeight) {
                                        setBoxHeight(moreBoxOffsetTop);
                                        clearTimeout(this);
                                    } else {
                                        clearTimeout(this);
                                        setTimeout(calculateHeight, 500);
                                    }
                                };
                                setTimeout(calculateHeight, 0);
                            },
                            className: "more-btn",
                            ref: moreRef,
                            posX: posX,
                            boxHeight: boxHeight,
                            hasMore: hasMore,
                            children: [
                                "더보기",
                                /*#__PURE__*/ _jsx(Icon, {
                                    icon: ArrowDown,
                                    size: Sizes.small,
                                    color: theme.new.colors.sol_indigo_500
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
export const SearchRecommendFilterWrap = styled.div.withConfig({
    componentId: "sc-24029248-0"
})(_templateObject(), (props)=>props.theme.new.colors.sol_gray_800, (props)=>props.theme.new.colors.sol_gray_600, themeGet("border.1", "#E8E8EA"), (props)=>props.theme.new.colors.sol_indigo_500, (props)=>props.theme.new.colors.sol_indigo_0, (props)=>props.theme.new.colors.sol_indigo_500, (props)=>props.theme.new.colors.sol_indigo_200, (props)=>props.theme.new.colors.sol_indigo_0);
const MoreBtn = styled.div.withConfig({
    componentId: "sc-24029248-1"
})(_templateObject1(), (param)=>{
    let { posX  } = param;
    return posX;
}, (props)=>props.theme.new.colors.sol_indigo_500, (props)=>props.theme.new.colors.sol_indigo_0, (param)=>{
    let { hasMore  } = param;
    return hasMore ? "1" : "0";
}, (param)=>{
    let { hasMore  } = param;
    return hasMore ? "auto" : "none";
}, (props)=>props.theme.new.colors.sol_indigo_100, themeGet("primary.0", "#002FA8"), (param)=>{
    let { boxHeight  } = param;
    return boxHeight;
}, (props)=>props.theme.new.colors.sol_gray_0, (props)=>props.theme.new.colors.sol_gray_600, themeGet("border.1", "#E8E8EA"));
